import React, { useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import { getAdjustmentReasons as apiGetAdjustmentReasons } from "../../../services/api";

import { withState } from "../../../services/state";

import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import Label from "../../components/label/Label";

import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  CircularProgress,
} from "@mui/material";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
    padding: "1rem",
  },
  marginTop: {
    marginTop: "1rem",
  },
});

function EditEventFeeForm({ classes, payload, storePayload, context }) {
  const [adjustmentReasons, setAdjustmentReasons] = useState([]);
  const [loadingReasons, setLoadingReasons] = useState(true);
  const [selectedReason, setSelectedReason] = useState(payload.reason || "");
  const [customReason, setCustomReason] = useState(payload.customReason || "");

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const reasons = await apiGetAdjustmentReasons(
          context.currentClub.clubId
        );
        if (reasons.length > 0) {
          setAdjustmentReasons(reasons);
        } else {
          setSelectedReason("other");
        }
      } catch (error) {
        console.error("Failed to fetch adjustment reasons", error);
      } finally {
        setLoadingReasons(false);
      }
    };
    fetchReasons();
  }, [context.currentClub.clubId]);

  const handleReasonChange = (event) => {
    const reason = event.target.value;
    console.log("reason", reason);
    setSelectedReason(reason);
    storePayload({
      ...payload,
      adjustmentReasonId: reason === "other" ? null : reason,
      newAdjustmentReason: "",
    });
  };

  const handleCustomReasonChange = (event) => {
    const custom = event.target.value;
    console.log("custom", custom);
    setCustomReason(custom);
    storePayload({
      ...payload,
      newAdjustmentReason: custom,
    });
  };

  return (
    <div className={classes.section}>
      <SingleLineTextInput
        label="EVENT FEE"
        value={payload.currentFee}
        onChange={(value) => storePayload({ ...payload, currentFee: value })}
        startAdornment="£"
      />

      <FormControl component="fieldset" className={classes.marginTop}>
        <Label title={"ADJUSTMENT REASON"} />
        {loadingReasons ? (
          <CircularProgress size={24} />
        ) : (
          <>
            {adjustmentReasons.length > 0 && (
              <RadioGroup value={selectedReason} onChange={handleReasonChange}>
                {adjustmentReasons.map((adjustmentReason) => (
                  <FormControlLabel
                    key={adjustmentReason.id}
                    value={adjustmentReason.id}
                    control={<Radio />}
                    label={adjustmentReason.reason}
                  />
                ))}
                <FormControlLabel
                  value="other"
                  control={<Radio />}
                  label="Other"
                />
              </RadioGroup>
            )}
          </>
        )}
      </FormControl>

      {selectedReason === "other" && (
        <TextField
          label="Enter custom reason"
          value={customReason}
          onChange={handleCustomReasonChange}
          fullWidth
          className={classes.marginTop}
        />
      )}
    </div>
  );
}

export default withState(withStyles(styles)(EditEventFeeForm));
